import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  margin: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: ${props => props.theme.background};
  overflow: scroll;
`;
export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0 32px;
  justify-content: center;
  align-items: center;
`;
